<mat-form-field>
  <input
    matInput
    type="text"
    placeholder="Page name (Key)"
    autocomplete="off"
    [(ngModel)]="value"
    (ngModelChange)="propagateChange($event)"
    [disabled]="isDisabled"
    (blur)="onTouched()"
  />
</mat-form-field>
<p class="text-reduced-bold"><span class="action">Check translations in Lokalise</span></p>
<p class="description tertiary">Remember to add the English and Arabic translations in the Lokalise system.</p>
